function directive() {
    return {
        link: function ($scope, element) {
            $scope.$on('treeChart', function (event, root, params) {
                var width = $("#treechart").parent().width(),
                    height = params["height"];
                var duration = 750, circleRadius = 4.5;

                var cluster = d3.layout.cluster()
                    .size([height, width - 230]);

                var nodeColor = function (severity) {
                    switch (severity) {
                        case 1:
                            return "#377FC7";
                            break;
                        case 2:
                            return "#F5D800";
                            break;
                        case 3:
                            return "#F88B12";
                            break;
                        case 4:
                            return "#DD122A";
                            break;
                        default:
                        return "#377FC7";
                    }
                };

                // toggle children on click.
                function click(d) {
                    if (d.children) {
                        d._children = d.children;
                        d.children = null;
                    } else {
                        d.children = d._children;
                        d._children = null;
                    }
                    update(d);
                }

                var diagonal = d3.svg.diagonal()
                    .projection(function (d) {
                        return [d.y, d.x];
                    });

                var svgOutter = d3.select("#treechart").append("svg")
                    .attr("width", width)
                    .attr("height", height);
                var svg = svgOutter.append("g")
                    .attr("transform", "translate(90,0)");

                function update(source) {
                    var divHeight;
                    var nodes = cluster.nodes(root),
                        links = cluster.links(nodes);

                    var lastNode = 0;
                    for (var n in nodes) {
                        if (typeof nodes[n].children === "undefined") {
                            lastNode++;
                        }
                    }

                    if (lastNode >= 35) {
                        divHeight = lastNode * 12;
                    } else {
                        divHeight = 420;
                    }
                    cluster.size([divHeight, width - 230]);

                    nodes = cluster.nodes(root);
                    links = cluster.links(nodes);

                    var node = svg.selectAll(".conn")
                        .data(nodes, function (d,i) {
                            return d.idd || (d.idd = ++i);
                        });

                    var nodeEnter = node.enter().append("g")
                        .attr("class", "conn")
                        .attr("transform", function (d) {
                            return "translate(" + d.y + "," + d.x + ")";
                        })
                        .on("click", click);

                    nodeEnter.append("circle")
                        .attr("fill",function(d) {
                            return nodeColor(d.severity);
                        })
                        .attr("stroke", "#000")
                        .attr("stroke-width", "0.7px")
                        .attr("r", circleRadius);

                    nodeEnter.append("text")
                        .attr("dx", function (d) {
                            return d.children ? -8 : 8;
                        })
                        .attr("dy", 3)
                        .attr("font-weight", function (d) {
                            return d.idRoute ? "bold" : 400;
                        })
                        .style("text-anchor", function (d) {
                            return d.children ? "end" : "start";
                        })
                        .text(function (d) {
                            return d.name;
                        });

                    // transition nodes to their new position.
                    var nodeUpdate = node.transition()
                        .duration(duration)
                        .attr("transform", function (d) {
                            return "translate(" + d.y + "," + d.x + ")";
                        });

                    nodeUpdate.select("circle")
                        .attr("fill",function(d) {
                            return nodeColor(d.severity);
                        })
                        .attr("stroke", "#000")
                        .attr("stroke-width", "0.7px")
                        .attr("r", circleRadius);

                    nodeUpdate.select("text")
                        .style("fill-opacity", 1);

                    // transition exiting nodes to the parent's new position.
                    var nodeExit = node.exit().transition()
                        .duration(duration)
                        .attr("transform", function () {
                            return "translate(" + source.y + "," + source.x + ")";
                        })
                        .remove();

                    nodeExit.select("circle")
                        .attr("fill",function(d) {
                            return nodeColor(d.severity);
                        })
                        .attr("stroke", "#000")
                        .attr("stroke-width", "0.7px")
                        .attr("r", circleRadius);

                    nodeExit.select("text")
                        .style("fill-opacity", "1");

                    // update the links…
                    var link = svg.selectAll(".conn_link")
                        .data(links, function (d) {
                            return d.target.idd;
                        });

                    // enter any new links at the parent's previous position.
                    link.enter().insert("path", "g")
                        .attr("d", diagonal)
                        .attr("class", "conn_link")
                        .attr("stroke-width", "1px");

                    // transition links to their new position.
                    link.transition()
                        .duration(duration)
                        .attr("stroke-width", "1px")
                        .attr("d", diagonal);

                    // transition exiting nodes to the parent's new position.
                    link.exit().transition()
                        .duration(duration)
                        .attr("d", function () {
                            var o = {
                                x: source.x,
                                y: source.y
                            };
                            return diagonal({
                                source: o,
                                target: o
                            });
                        })
                        .remove();

                    // stash the old positions for transition.
                    nodes.forEach(function (d) {
                        d.x0 = d.x;
                        d.y0 = d.y;
                    });
                    $scope.$broadcast('adjustHeight', divHeight);
                }

                // root.children.forEach(collapse);
                update(root);
                d3.select(self.frameElement).style("height", height + "px");

                $scope.$on('adjustHeight', function (event, newHeight) {
                    svgOutter.attr("height", height)
                        .transition()
                        .duration(duration)
                        .attr("height", newHeight);
                    d3.select(self.frameElement)
                        .style("height", height + "px")
                        .transition()
                        .duration(duration)
                        .style("height", newHeight + "px");
                    height = newHeight;
                });

                $scope.$on('$destroy', function () {
                    element.remove();
                });
            })
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/treechart/maketreechart.js
 **/